module.exports = __webpack_public_path__ + "static/media/background_premium_promo.5badf653.jpg";